import { Button, Text } from '@chakra-ui/react';
import {
  ModalOrDrawerBody,
  ModalOrDrawerFooter,
} from '@ui/components/ModalOrDrawer';
import { useCoinMode } from '@ui/hooks/useCoinMode';
import { useTranslations } from '@ui/i18n';
import { getGardenName } from '@ui/utils/garden';

import { useGardenNftDrawerStore } from '../GardenNftDrawersShared/useGardenNftDrawer';
import { useGrowHelpers } from '../GrowHelpersProvider';

const SuccessContent = () => {
  const t = useTranslations();
  const coinMode = useCoinMode();
  const onClose = useGardenNftDrawerStore((s) => s.onClose);
  const { gardenType } = useGrowHelpers();
  const selectedTokens = useGardenNftDrawerStore((s) => s.selectedTokens);

  return (
    <>
      <ModalOrDrawerBody alignItems="center">
        <Text textStyle="h3" textAlign="center">
          {t('Transaction completed!')}
        </Text>
        <Text
          mt="24px"
          mx="auto"
          maxW="300px"
          textStyle="body"
          textAlign="center"
        >
          {t('You have unstaked {num} NFT in {platform}', {
            num: selectedTokens.length,
            platform: getGardenName(coinMode, gardenType),
          })}
        </Text>
      </ModalOrDrawerBody>
      <ModalOrDrawerFooter>
        <Button onClick={onClose}>{t('Done')}</Button>
      </ModalOrDrawerFooter>
    </>
  );
};

export default SuccessContent;
